import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../shared/Button';
import Text from '../../shared/Typography';
import CodeBlock from './CodeBlock';

const Buttons = () => {
  const { t } = useTranslation('buttons');
  return (
    <React.Fragment>
      <Text h2 className='pattern-library__section-title'>{t('buttons')}</Text>
      <CodeBlock>{t('info')}</CodeBlock>

      <Text h3 className='pattern-library__title'>{t('diff_types')}</Text>
      <Button
        label={t('primary')}
        className='is-primary'
      />
      <Button
        label={t('secondary')}
        className='is-secondary'
      />
      <Button
        label={t('primary_seq')}
        className='is-primary is-sequential'
      />
      <Button
        label={t('primary_block')}
        className='is-primary is-block'
      />
      <Text h3 className='pattern-library__title'>{t('diff_states')}</Text>
      <Button
        label={t('waiting')}
        className='is-waiting'
      />
      <Button
        label={t('processing')}
        className='is-processing'
      />
    </React.Fragment>
  );
};

export default Buttons;



// WEBPACK FOOTER //
// ./src/components/pages/pattern-library/buttons.js